import React, { useCallback } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Ballad } from '@digimap/types'
import FilterableBalladsMapList from './components/FilterableBalladsMapList'

interface AdminBalladsContainerProps
  extends RouteComponentProps<{
    balladStatus?: string
    balladType?: string
  }> {}

export default function AdminBalladsContainer(
  props: AdminBalladsContainerProps
) {
  const onBalladClickMemo = useCallback(
    (ballad: Ballad) => {
      props.history.push(`/admin/ballads/${ballad.slug}`)
    },
    [props.history]
  )

  return (
    <FilterableBalladsMapList
      onBalladClick={onBalladClickMemo}
      balladType={props.match.params.balladType}
      showIfCompleted={false}
      showOnlyIfRouted={false}
      displayDraft={true}
    />
  )
}
